<template>
  <div class="row">
    <div class="col">
      <div class="card">
        <!-- Card header -->
        <card-header :title="$router.currentRoute.meta.title" >
          <router-link v-if="!serverError" :to="{ name: `${routePrefix}.edit`,params:{id} }"  class="btn btn-primary btn-sm" v-can:edit="permissionPrefix">
            <i class="fa fa-edit"></i>
          </router-link>
        </card-header>
        <!-- Card body -->
          <div class="card-body">
            <div class="row">
              <div class="col-6">
                <div v-if="serverError" class="alert alert-danger">
                  <strong>{{ $t('labels.error') }} : </strong> {{ serverError }}
                </div>
              </div>
            </div>
            <div class="row" v-if="!serverError">
              <input-text v-model="en_name" :options="{ id: 'en_name', label: 'en_name', disabled: true }"/>
              <input-text v-model="ar_name" :options="{ id: 'ar_name', label: 'ar_name', disabled: true }"/>
              <input-text v-model="short_name" :options="{ id: 'short_name', transPrefix: `${transPrefix}.fields`, label: 'short_name', disabled: true }"/>
              <input-text v-model="code_2" :options="{ id: 'code_2', transPrefix: `${transPrefix}.fields`, label: 'code_2', disabled: true }"/>
              <input-text v-model="code_3" :options="{ id: 'code_3', transPrefix: `${transPrefix}.fields`, label: 'code_3', disabled: true }"/>
              <input-text v-model="mobile_country_code" :options="{ id: 'mobile_country_code', transPrefix: `${transPrefix}.fields`, label: 'mobile_country_code', disabled: true }"/>
              <input-number v-model="mobile_number_length" :options="{ id: 'mobile_number_length', step: 1, transPrefix: `${transPrefix}.fields`, label: 'mobile_number_length', disabled: true }"/>
              <input-number v-model="tax_rate" :options="{ id: 'tax_rate', transPrefix: `${transPrefix}.fields`, label: 'tax_rate', disabled: true }"/>
              <input-text v-model="currency_en_name" :options="{ id: 'currency_en_name', transPrefix: `${transPrefix}.fields`, label: 'currency.en_name', disabled: true }"/>
              <input-text v-model="currency_ar_name" :options="{ id: 'currency_ar_name', transPrefix: `${transPrefix}.fields`, label: 'currency.ar_name', disabled: true }"/>
            </div>
            <div class="row" v-if="!serverError">
              <div class="col-12">
                <maps-general v-model="points" :points="oldPoints" :mode="map_mode"/>
              </div>
            </div>
          </div>
          <!-- Card footer -->
          <div class="card-footer">
            <div class="row">
              <div class="col text-right">
                <router-link :to="{ name: `${routePrefix}.index`}"  class="btn btn-neutral btn-sm">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { COUNTRIES_SHOW as CRUD_ACTION_SHOW } from 'actions/countries';
  const CRUD_CODE="countries";
  export default {
    name: "CountryShow",
    data(){
      return {
        routePrefix: CRUD_CODE,
        transPrefix: CRUD_CODE,
        permissionPrefix: CRUD_CODE,
        id:this.$router.currentRoute.params.id,
        en_name: '',
        ar_name: '',
        short_name: '',
        code_2: '',
        code_3: '',
        mobile_country_code: '',
        mobile_number_length: "",
        tax_rate: "",
        currency_en_name:"",
        currency_ar_name:"",
        points:[],
        oldPoints:[],
        map_mode:'show',
        serverError: '',
        responseStatus:'',
      }
    },
    mounted() {
      this.getItem();
    },
    methods: {
      getItem(){
        this.$store.dispatch(CRUD_ACTION_SHOW,{
          id: this.id,
        }).then(response=>{
          this.en_name=response.data.name;
          this.ar_name=response.data.nameAr;
          this.short_name=response.data.shortName;
          this.code_2=response.data.code2
          this.code_3=response.data.code3;
          this.mobile_country_code=response.data.mobileCountryCode;
          this.mobile_number_length=response.data.mobileNumberLength;
          this.tax_rate=response.data.taxRate;
          this.currency_en_name=response.data.currency?response.data.currency.name:'';
          this.currency_ar_name=response.data.currency?response.data.currency.nameAr:'';
          this.oldPoints=this.points=response.data.geom?response.data.geom.coordinates[0][0]:[];
        }).catch(error => {
          this.loading = false
          this.serverError='';

          if(error.response){
            this.responseStatus=error.response.status;
            let responseData=error.response.data;

            if(responseData.errors){
              this.fieldErrors=responseData.errors;
            }else{
              this.serverError = 'Invalid Request.'
            }
          }else{
            this.serverError = this.$i18n.t("messages.no_internet_connection");
          }

          if(this.fieldErrors.error){
            this.serverError = this.fieldErrors.error;
          }
        });
      },
    }
  };
</script>
